import React, { useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { pick, omit } from "lodash";
import { Transition as Trans } from "react-transition-group";
import { TransitionStyle } from "./transition.style";

const TransitionPropTypeKeys = [
  "in",
  "mountOnEnter",
  "unmountOnExit",
  "appear",
  "enter",
  "exit",
  "timeout",
  "onEnter",
  "onEntering",
  "onEntered",
  "onExit",
  "onExiting",
  "onExited"
];

const Transition = ({
  className,
  activeClassName,
  children,
  innerRef,
  ...props
}) => {
  const transitionProps = pick(props, TransitionPropTypeKeys);
  const attributes = omit(props, TransitionPropTypeKeys);
  let ref = useRef(null);
  if (typeof innerRef === "object") {
    ref = innerRef;
  }
  typeof innerRef === "function" && innerRef(ref);

  return (
    <Trans {...transitionProps} nodeRef={ref}>
      {(status) => {
        const isActive = status === "entered";
        const classes = classNames(
          className,
          isActive && activeClassName,
        );

        return (
          <TransitionStyle isActive={isActive} className={classes} {...attributes}>{children}</TransitionStyle>
        );
      }}
    </Trans>
  );
};

Transition.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  activeClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  timeout: PropTypes.number,
  appear: PropTypes.bool,
  enter: PropTypes.bool,
  exit: PropTypes.bool,
  in: PropTypes.bool,
};

Transition.defaultProps = {
  timeout: 150,
  appear: true,
  enter: true,
  exit: true,
  in: true
};

export default Transition;
